import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { Countries } from '../shared/libraries/countries';

bus.on(constants.EVENTS.COUNTRY.SELECT, (data) => {
  let countryCodes = data.countries;
  let countryChoices = [];
  if (countryCodes == 'all') countryChoices = Countries.get();
  else if (Array.isArray(countryCodes))
    countryChoices = Countries.getByCountryCode(countryCodes);
  const store = getStore('country');
  store.state.countryChoices = countryChoices;
  store.state.countryChoiceConf = {
    title: data.title || '',
    descirption: data.descirption || '',
    optionDesc: typeof data.optionDesc == 'object' ? data.optionDesc : {},
    selectOnClick: !!data.selectOnClick
  };
  store.state.countryChoiceConf.default = data.optionDesc?.default ?? '';
});

bus.on(constants.EVENTS.COUNTRY.SELECTION_CONFIRMED, () => {
  const store = getStore('country');
  if (!store.state.activeChoice) return;
  const data = {
    id: store.state.selectionRequestId,
    country: store.state.activeChoice
  };
  bus.emit(constants.EVENTS.COUNTRY.SELECTED, JSON.parse(JSON.stringify(data)));
});

bus.on(constants.EVENTS.CURRENCY.SELECT, (data) => {
  const store = getStore('country');
  store.state.currencySelectionRequestId = data.id;
  store.state.activeCurrencyChoice = null;
  store.state.isMultiCurrencySelection = data.multiSelect || false;

  // Handle preselected currencies
  if (data.preselected) {
    store.state.preselectedCurrencies = Array.isArray(data.preselected)
      ? data.preselected
      : [data.preselected];
  } else {
    store.state.preselectedCurrencies = [];
  }

  // Initialize selected currencies based on preselected
  store.state.selectedCurrencies = [...store.state.preselectedCurrencies];

  // Load currencies with flags
  const currencyChoices = Countries.getCurrenciesWithFlags();
  store.state.currencyChoices = currencyChoices;
});

bus.on(constants.EVENTS.CURRENCY.SELECTION_CONFIRMED, () => {
  const store = getStore('country');

  if (store.state.isMultiCurrencySelection) {
    // Multi-selection mode: return array of selected currencies
    const selectedCurrencies = store.state.currencyChoices.filter((currency) =>
      store.state.selectedCurrencies.includes(currency.code)
    );

    const data = {
      id: store.state.currencySelectionRequestId,
      currencies: selectedCurrencies,
      currencyCodes: store.state.selectedCurrencies,
      multiSelect: true
    };
    bus.emit(
      constants.EVENTS.CURRENCY.SELECTED,
      JSON.parse(JSON.stringify(data))
    );
  } else {
    // Single selection mode: return single currency
    if (!store.state.activeCurrencyChoice) return;
    const data = {
      id: store.state.currencySelectionRequestId,
      currency: store.state.activeCurrencyChoice,
      multiSelect: false
    };
    bus.emit(
      constants.EVENTS.CURRENCY.SELECTED,
      JSON.parse(JSON.stringify(data))
    );
  }
});
